(function () {
  'use strict';

  angular
    .module('unit.cancel.deal')
    .controller('unitCancelDealCtrl', unitCancelDealCtrl);

  unitCancelDealCtrl.$inject = [
    '$mdDialog',
    'UnitCancelDeal',
    '$scope',
    'titleText',
    'onCancel',
    'onBack',
    'dealId',
    '$rootScope',
  ];

  function unitCancelDealCtrl(
    /** @type {angular.material.IDialogService} */ $mdDialog,
    UnitCancelDeal,
    $scope,
    titleText,
    onCancel,
    onBack,
    dealId,
    $rootScope,
  ) {
    var vm = this;

    $scope.titleText = titleText;

    vm.cancel = {
      custom_field: {},
    };

    vm.customFields = UnitCancelDeal.getCancelCustomFields(
      function (customFields) {
        vm.loaded = true;
      },
    );

    vm.cancelDeal = function () {
      UnitCancelDeal.cancelDeal({ id: dealId }, vm.cancel, function () {
        $mdDialog.hide();
        onCancel();
        //$rootScope.$broadcast('activity.update');
      });
    };

    vm.closeDialog = function () {
      $mdDialog.hide();
      onBack();
    };
  }
})();
